import React, { useMemo } from 'react';
import { Card, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { CompetencyScore, JohariQuadrant } from '../../types';

interface JohariWindowProps {
  scores: CompetencyScore[];
}

interface QuadrantConfig {
  key: JohariQuadrant;
  titleKey: string;
  bg: string;
}

const QUADRANTS: QuadrantConfig[] = [
  { key: 'open', titleKey: 'review360.johari.open', bg: 'teal.1' },
  { key: 'blind_spot', titleKey: 'review360.johari.blindSpot', bg: 'red.1' },
  { key: 'hidden_strength', titleKey: 'review360.johari.hiddenStrength', bg: 'blue.1' },
  { key: 'unknown', titleKey: 'review360.johari.unknown', bg: 'gray.1' },
];

export const JohariWindow: React.FC<JohariWindowProps> = ({ scores }) => {
  const { t } = useTranslation();

  const grouped = useMemo(() => {
    const map: Record<JohariQuadrant, string[]> = {
      open: [],
      blind_spot: [],
      hidden_strength: [],
      unknown: [],
    };
    for (const score of scores) {
      if (score.quadrant) {
        map[score.quadrant].push(score.sectionTitle);
      }
    }
    return map;
  }, [scores]);

  return (
    <Card withBorder radius="md" p="lg">
      <Title order={4} mb="md">
        {t('review360.johariWindow')}
      </Title>
      <SimpleGrid cols={2} spacing="sm">
        {QUADRANTS.map((q) => (
          <Card key={q.key} bg={q.bg} radius="md" p="md">
            <Stack gap="xs">
              <Text fw={600} size="sm">
                {t(q.titleKey)}
              </Text>
              {grouped[q.key].length > 0 ? (
                grouped[q.key].map((title) => (
                  <Text key={title} size="sm">
                    {title}
                  </Text>
                ))
              ) : (
                <Text size="sm" c="dimmed">
                  —
                </Text>
              )}
            </Stack>
          </Card>
        ))}
      </SimpleGrid>
    </Card>
  );
};
